import { Status } from '../shared/enums';

export const isAllowedToBeInSpecialCollection = (puzzle: {
  status: Status;
  collections: string[];
}) => {
  const statuesWithoutSpecialCollections: string[] = [Status.Pending, Status.New, Status.Approved];

  const specialCategoriesNames: string[] = [Status.Rejected, Status.Deleted, Status.Disabled];

  if (
    statuesWithoutSpecialCollections.includes(puzzle.status) &&
    puzzle.collections.some((collectionId) => specialCategoriesNames.includes(collectionId))
  ) {
    return false;
  }

  return true;
};
